import React, {useState, useEffect, useRef} from 'react';
import {
   View,
   Text,
   ImageBackground,
   SafeAreaView,
   Image,
   BackHandler,
   TouchableOpacity,
   Platform,
   Dimensions,
   Modal,
} from 'react-native';
import {
   FONT_FAMILY_REGULAR,
   FONT_FAMILY_BOLD,
   calculatePassingPercentage,
   TRAINING_LIST_BASE_URL,
   setWebNavTitle,
   rectifyBooleanString,
} from '../../utils/utils';
import ReviewQuestionList from './ReviewQuestionsList';
import FinalQuestionList from './FinalQuestionList';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
   setIsLandscapemode,
} from '../../redux/slices/ScreenOrientationSlice';
import {useDispatch, useSelector} from 'react-redux';
import ReviewAnswerResponseScreen from './ReviewAnswerResponseScreen';
import {useNavigation} from '@react-navigation/native';
import StartFinalTest from './StartFinalTest';
import {selectCourseId} from '../../redux/slices/CourseIdSlice';
import CustomImageViewer from '../../utils/ImageViewer';
import logger from '../../utils/logger';
import {Popup} from '../../components/popup';
import Asl from '../../components/asl';
import VideoPlayer from '../../components/asl/VideoPlayer';
import {isTablet} from 'react-device-detect';
import {selectAslType, selectAslVolume} from '../../redux/slices/AslSlice';
import ASLVolume from '../../components/asl/ASLVolume';
let arrFinalQuesAnswered = [];
let answerData = [];
let incoreectFinalQuesAnsData = [];
const ReviewQuestionScreen = props => {
   const navigation = useNavigation();
   const [isImageAvailable, setImageAvailable] = useState(false);
   const {
      finalQuesAnsData,
      moduleIndex,
      currentSlide,
      isReviewTest,
      percentageRequirement,
      isFinalTest,
      isPreTeastEnable,
      titleHancler,
      isFinalTestReviewEnable,
      iQData,
      finalReviewSubmited,
   } = props;
   const courseId = useSelector(selectCourseId);
   const [imageURL, setImageURL] = useState();
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const AslType = useSelector(selectAslType);
   const alsVolume = useSelector(selectAslVolume);
   const [currentFinalQuesIndex, setCurrentFinalQuesIndex] = useState(0);
   const incrementFinalQuesIndex = () => {
      setCurrentFinalQuesIndex(currentFinalQuesIndex + 1);
   };
   var index = parseInt(moduleIndex) + 1;
   var slide = parseInt(currentSlide) + 1;
   const quesId = isReviewTest
      ? finalQuesAnsData?.TestItemID
      : finalQuesAnsData?.[currentFinalQuesIndex].TestItemID;
   const finalString = 'QID: ' + quesId + ' M: ' + index + ' S: ' + slide;
   const [isModalActionSheetVisible, setIsModalActionSheetVisible] =
      useState(false);
   const [isImageViewer, setImageViewer] = useState(false);
   const [isCorrectAnswer, setCorrectAnswer] = useState(false);
   const [isRetryPressed, setRetryPressed] = useState(false);
   const [isFinalTestStart, setFinalTestStart] = useState(false);
   const [playALSVideo, setPlayALSVideo] = useState(false);
   const [isAslQuestion, setAslQuestion] = useState(false);
   const [ALSVideoUrl, setAlsVideoUrl] = useState(false);
   const [playALSAudio, setPlayALSAudio] = useState(false);
   const [progressALSVideo, setProgressALSVideo] = useState(0);
   const [playMediaItem, setPlayMediaItem] = useState(false); //Used in flat list
   const quesImage = isReviewTest
      ? finalQuesAnsData.QuestionImage
      : finalQuesAnsData[currentFinalQuesIndex].QuestionImage;

   useEffect(() => {
      if (finalQuesAnsData?.[currentFinalQuesIndex]?.QuestionImage) {
         const updatedImage = finalQuesAnsData[currentFinalQuesIndex].QuestionImage;
         setImageURL(TRAINING_LIST_BASE_URL + courseId + updatedImage);
         setImageAvailable(true);
      } else {
         setImageURL('');
         setImageAvailable(false);
      }
   }, [currentFinalQuesIndex, finalQuesAnsData]);
   
   
   //Final test review Data manupulation
   const tempQestionAnseredDataList = isFinalTestReviewEnable
      ? iQData.split(';')
      : [];
   const filteredQuestionAndAnseredID =
      tempQestionAnseredDataList.length > 0
         ? tempQestionAnseredDataList.filter(str => str.startsWith(quesId))[0]
         : '';
   const wrongAnserID =
      filteredQuestionAndAnseredID != ''
         ? filteredQuestionAndAnseredID.split(':')[1]
         : '';
   //Final test review Data manupulation ended
   const dispatch = useDispatch();
   function handleFinalTestAnswerClicked(item) {
      
      answerData = [...answerData, item];
      logger('answerData::', answerData);

      createSelectedQuesAnswerData(item);
      handleQuestionImages();
      if (finalQuesAnsData.length - 1 > currentFinalQuesIndex) {
         incrementFinalQuesIndex();
      } else {
         const correctAnswerLength = findCorrectAnswerLength(answerData);
         const totalQues = finalQuesAnsData.length;
         const percentage = calculatePassingPercentage(
            totalQues,
            correctAnswerLength,
         );
         var isPassed = false;
         if (percentage < parseInt(percentageRequirement)) {
            isPassed = false;
         } else {
            isPassed = true;
         }

         const qDataAns = arrFinalQuesAnswered.join(';');
         const percentageVal = Math.floor(percentage);
         navigation.navigate('ScoreBoard', {
            navigation: navigation,
            isPassed: isPassed,
            questionAsked: totalQues,
            finalScore: percentageVal,
            correctAnswerCount: correctAnswerLength,
            qData: qDataAns,
            moduleIndex: moduleIndex,
            qCorrect: correctAnswerLength,
            percentageRequirement: percentageRequirement,
            isPreTeastEnable: isPreTeastEnable,
            closeFullscreen: () => props.closeFullscreen(),
            incorrectQuestionList: incoreectFinalQuesAnsData,
            currentSlide: currentSlide,
         });
      }
   }

   function findCorrectAnswerLength(answerData) {
      var correctAnswerLength = 0;
      for (let index = 0; index < answerData.length; index++) {
         const item = answerData[index];
         if (item.CorrectAnswer == 'true') {
            correctAnswerLength = correctAnswerLength + 1;
         }
      }
      return correctAnswerLength;
   }
   function createSelectedQuesAnswerData(item) {
      var qData = '';
      if (item.CorrectAnswer == 'true') {
         qData += quesId + ':' + item.AnswerID + ':1';
      } else {
         qData += quesId + ':' + item.AnswerID + ':0';
         const incorrectQuestion = finalQuesAnsData.filter(
            data => data.TestItemID === quesId,
         );
         if (incorrectQuestion.length > 0) {
            incoreectFinalQuesAnsData = [
               ...incoreectFinalQuesAnsData,
               incorrectQuestion[0],
            ];
         }
      }
      arrFinalQuesAnswered = [...arrFinalQuesAnswered, qData];
   }
   // function handleQuestionImages() {
   //    if (quesImage != '') {
   //       logger('quesImage::', quesImage);
   //       setImageURL(TRAINING_LIST_BASE_URL + courseId + quesImage);
   //       setImageAvailable(true);
   //    } else {
   //       logger('quesImage::', quesImage);
   //       setImageAvailable(false);
   //    }
   // }
   function handleQuestionImages() {
      return;
   }
   let title = isPreTeastEnable
      ? 'Pre Test'
      : isFinalTest
      ? 'Final Test'
      : 'Review Question';
   title = isFinalTestReviewEnable ? 'Final Test Review' : title;
   titleHancler(title);
   setWebNavTitle(navigation, title);
   useEffect(() => {
      //clearing answer data if available...
      arrFinalQuesAnswered = [];
      answerData = [];
      incoreectFinalQuesAnsData = [];
      handleQuestionImages();
      const backAction = () => {
         return true;
      };
      const backHandler = BackHandler.addEventListener(
         'hardwareBackPress',
         backAction,
      );
      return () => backHandler.remove();
   }, []);

   const isWeb = Platform.OS === 'web';
   return (
      <View
         style={{
            width: '100%',
            height: '100%',
            ...Platform.select({
               web: {
                  minWidth: isLandscapeSmallWebView ? '100vw' : null,
                  paddingBottom: isFinalTest
                     ? 0
                     : isLandscapeSmallWebView
                     ? 12
                     : isLandscapeMode
                     ? 0
                     : 0,
               },
            }),
         }}>
         {!isReviewTest && !isFinalTestStart ? (
            <View style={{flex: 1}}>
               <StartFinalTest
                  moduleIndex={index}
                  requiredPercentage={percentageRequirement}
                  proceed={() => {
                     setFinalTestStart(true);
                     props.onBeginTest();
                  }}
                  isPreTeastEnable={isPreTeastEnable}
                  isFinalTestReviewEnable={isFinalTestReviewEnable}
               />
            </View>
         ) : (
            <SafeAreaView style={{flex: 1}}>
               <ImageBackground
                  style={{flex: 1, resizeMode: 'contain', overflow: 'hidden'}}
                  // source={
                  //    !isReviewTest
                  //       ? require('../../assets/bg_final_test.png')
                  //       : null
                  // }
                  // Bcoz BG image not needed anymore for question screen, hence:
                  source={null}>
                  {!isReviewTest ? (
                     <View
                        style={{
                           position: 'absolute',
                           width: '100%',
                           height: '100%',
                           resizeMode: 'contain',
                           overflow: 'hidden',
                           opacity: 0.5,
                        }}
                     />
                  ) : null}
                  <View
                     style={{
                        height: isLandscapeMode ? 92 : 50,
                        marginLeft: isLandscapeMode ? 24 : 16,
                        marginRight: isLandscapeMode ? 24 : 16,
                        marginTop: isLandscapeMode ? 24 : 16,
                        flexDirection: 'row',
                        backgroundColor: '#202020',
                        borderRadius: 8,
                        ...Platform.select({
                           web: {
                              height: !isLandscapeSmallWebView ? 92 : 50,
                              marginLeft: !isLandscapeSmallWebView ? 24 : 16,
                              marginRight: !isLandscapeSmallWebView ? 24 : 16,
                              marginTop: !isLandscapeSmallWebView ? 24 : 16,
                              fontSize: !isLandscapeSmallWebView ? 14 : 16,
                           },
                        }),
                     }}>
                     <View
                        style={{
                           flex: isLandscapeMode ? 0.95 : 0.85,
                           justifyContent: 'center',
                           ...Platform.select({
                              web: {
                                 flex: isLandscapeSmallWebView ? 0.65 : 0.55,
                              },
                           }),
                        }}>
                        <Text
                           style={{
                              fontSize: isLandscapeMode ? 36 : 20,
                              fontFamily: FONT_FAMILY_REGULAR,
                              color: 'white',
                              marginLeft: isLandscapeMode ? 24 : 16,
                              fontWeight: isLandscapeMode ? '700' : '600',
                              ...Platform.select({
                                 web: {
                                    fontSize:
                                       isLandscapeSmallWebView ||
                                       !isLandscapeMode
                                          ? 20
                                          : 36,
                                    marginLeft: !isLandscapeSmallWebView
                                       ? 24
                                       : 16,
                                    fontWeight: !isLandscapeSmallWebView
                                       ? '700'
                                       : '600',
                                 },
                              }),
                           }}>
                           {isReviewTest
                              ? 'Review Question'
                              : isPreTeastEnable
                              ? 'Pre Test'
                              : isFinalTestReviewEnable
                              ? 'Final Test Review'
                              : 'Final Test'}
                        </Text>
                     </View>

                     <View
                        style={{
                           flex: isLandscapeMode ? 0.15 : 0.2,
                           marginRight: isLandscapeMode ? 24 : 16,
                           justifyContent: 'center',
                           alignItems: 'flex-end',
                           ...Platform.select({
                              web: {
                                 flex: !isLandscapeSmallWebView ? 0.45 : 0.35,
                                 marginRight: 16,
                              },
                           }),
                        }}>
                        <Text
                           style={{
                              fontSize: isLandscapeMode ? 16 : 14,
                              fontFamily: FONT_FAMILY_BOLD,
                              color: '#FFFFFF',
                              fontWeight: '600',
                              ...Platform.select({
                                 web: {
                                    fontSize:
                                       isLandscapeSmallWebView ||
                                       !isLandscapeMode
                                          ? 14
                                          : 16,
                                 },
                              }),
                           }}>
                           {finalString}
                        </Text>
                     </View>
                  </View>
                  <View
                     style={{
                        marginTop: isLandscapeMode ? 24 : 8,
                        marginLeft: isLandscapeMode ? 25 : 16,
                        marginRight: isLandscapeMode ? 25 : 16,
                        flexDirection: 'row',
                        ...Platform.select({
                           web: {
                              marginTop: !isLandscapeSmallWebView ? 24 : 12,
                              marginLeft: !isLandscapeSmallWebView ? 25 : 16,
                              marginRight: !isLandscapeSmallWebView ? 25 : 16,
                              fontSize: !isLandscapeSmallWebView ? 16 : 14,
                           },
                        }),
                     }}>
                     <View style={{flex: 1}}>
                        <View
                           style={{
                              flexDirection: 'row',
                              alignItems: 'center',
                           }}>
                           <Text
                              style={{
                                 fontSize: isLandscapeMode ? 24 : 14,
                                 fontFamily: FONT_FAMILY_REGULAR,
                                 color: '#FFFFFF',
                                 opacity: 0.6,
                                 fontWeight: '600',
                                 ...Platform.select({
                                    web: {
                                       fontSize:
                                          isLandscapeSmallWebView ||
                                          !isLandscapeMode
                                             ? 14
                                             : 24,
                                       paddingBottom: !isLandscapeSmallWebView
                                          ? 5
                                          : null,
                                    },
                                 }),
                              }}>
                              Question:
                           </Text>
                           {((isFinalTest &&
                              finalQuesAnsData[currentFinalQuesIndex]
                                 ?.TestQuestionMediaRelativePath) ||
                              finalQuesAnsData?.TestQuestionMediaRelativePath) && (
                              <>
                                 <Asl
                                    url={
                                       isFinalTest
                                          ? finalQuesAnsData[
                                               currentFinalQuesIndex
                                            ].TestQuestionMediaRelativePath
                                          : finalQuesAnsData?.TestQuestionMediaRelativePath
                                    }
                                    showAlsVideo={url => {
                                       if (AslType === 'video') {
                                          setProgressALSVideo(0);
                                          setAslQuestion(true);
                                          // setPlayALSVideo(true);
                                          setAlsVideoUrl(url);
                                       } else {
                                          // setPlayALSAudio(true);
                                       }
                                    }}
                                    onMediaClicked={() => {
                                       if (props.onMediaClicked) {
                                          props?.onMediaClicked();
                                       }
                                       setPlayALSAudio(!playALSAudio);
                                       if (isAslQuestion) {
                                          setPlayALSVideo(!playALSVideo);
                                       } else {
                                          setPlayALSVideo(true);
                                          setPlayMediaItem(false);
                                       }
                                       setProgressALSVideo(0);
                                       setAslQuestion(true);
                                    }}
                                    progressALSVideo={
                                       isAslQuestion ? progressALSVideo : 0
                                    }
                                    isMediaPlaying={
                                       // AslType === 'video'
                                       //    ? playALSVideo
                                       //    : playALSAudio
                                       isAslQuestion ? playALSVideo : false
                                    }
                                    playAudio={() => {
                                       //setPlayALSVideo(true);
                                    }}
                                    isVideoPlaying={
                                       isAslQuestion ? playALSVideo : false
                                    }
                                    style={{
                                       marginLeft: 5,
                                       ...Platform.select({
                                          android: {
                                             marginTop: 4,
                                          },
                                          ios: {
                                             marginTop: 4,
                                             marginLeft: 5,
                                          },
                                          macos: {
                                             marginTop: 4,
                                          },
                                       }),
                                    }}
                                    onMediaFinished={() => {
                                       setPlayALSVideo(false);
                                    }}
                                    progCircleTintColor="#000"
                                 />
                                 {/* {AslType === 'audio' ? (
                                    <ASLVolume volume={alsVolume} />
                                 ) : null} */}
                              </>
                           )}
                        </View>
                        {/* <Text
                           style={{
                              marginTop: isLandscapeMode ? 16 : 8,
                              fontSize: isLandscapeMode ? 32 : 20,
                              fontFamily: FONT_FAMILY_BOLD,
                              color: 'white',
                              fontWeight: '600',
                              color: '#FFFFFF',
                              ...Platform.select({
                                 web: {
                                    marginTop: !isLandscapeSmallWebView
                                       ? 16
                                       : 8,
                                    fontSize: !isLandscapeSmallWebView
                                       ? 32
                                       : 20,
                                    fontSize: !isLandscapeSmallWebView
                                       ? 32
                                       : 20,
                                 },
                              }),
                           }}>
                           {isReviewTest
                              ? finalQuesAnsData?.Question.replace(
                                   '\u0019',
                                   "'",
                                )
                              : finalQuesAnsData?.[
                                   currentFinalQuesIndex
                                ].Question.replace('\u0019', "'")}
                        </Text> */}
                     </View>
                     {/* {isImageAvailable ? (
                        <ImageQuestionHeader
                           width={isLandscapeMode ? 150 : 150}
                           height={isLandscapeMode ? 52 : 52}
                           magnifierImageWidth={
                              !isWeb
                                 ? isLandscapeMode
                                    ? 50
                                    : 30
                                 : !isLandscapeSmallWebView
                                 ? 50
                                 : 30
                           }
                           magnifierImageHeight={
                              !isWeb
                                 ? isLandscapeMode
                                    ? 50
                                    : 30
                                 : !isLandscapeSmallWebView
                                 ? 50
                                 : 30
                           }
                           imageURL={imageURL}
                           onClick={() => {
                              setImageViewer(true);
                           }}
                        />
                     ) : null} */}
                  </View>
                  <View
                     style={{
                        flex: 1,
                        marginTop: isLandscapeMode ? 6 : 0,
                        ...Platform.select({
                           web: {
                              marginTop: null,
                           },
                        }),
                     }}>
                     {isReviewTest ? (
                        <View style={{flex: 1}}>
                           <ReviewQuestionList
                              answer={
                                 finalQuesAnsData.CourseTestItemAnswer
                                    .CourseTestItemAnswer
                              }
                              onRetryPressed={isRetryPressed}
                              isAslQuestion={isAslQuestion}
                              onRowSelected={item => {
                                 logger('Answer clicked', item);
                                 if (item.CorrectAnswer == 'true') {
                                    setCorrectAnswer(true);
                                 } else {
                                    setCorrectAnswer(false);
                                 }
                                 setRetryPressed(false);
                                 setIsModalActionSheetVisible(true);
                                 setPlayMediaItem(false);
                                 setAslQuestion(false);
                              }}
                              onSignButtonPress={url => {
                                 setProgressALSVideo(0);
                                 setAslQuestion(false);
                                 setPlayMediaItem(true);
                                 setAlsVideoUrl(url);
                              }}
                              onMediaClicked={isSameIndex => {
                                 if (isSameIndex) {
                                    setPlayMediaItem(!playMediaItem);
                                 } else {
                                    setPlayMediaItem(true);
                                 }
                                 setAslQuestion(false);
                              }}
                              progressALSVideo={
                                 !isAslQuestion ? progressALSVideo : 0
                              }
                              isMediaPlaying={
                                 !isAslQuestion ? playMediaItem : false
                              }
                              isLandscapeMode={isLandscapeMode}
                              isSmallScreen={() => isLandscapeSmallWebView}
                              finalQuesAnsData={finalQuesAnsData}
                              isImageAvailable={isImageAvailable}
                              isWeb={isWeb}
                              imageURL={imageURL}
                              onImageViewerPressed={() => {
                                 setImageViewer(true);
                              }}
                              didVideoStopped={
                                 isAslQuestion ? !playALSVideo : !playMediaItem
                              }
                           />
                        </View>
                     ) : (
                        <View style={{flex: 1}}>
                           <FinalQuestionList
                              answer={
                                 finalQuesAnsData[currentFinalQuesIndex]
                                    .CourseTestItemAnswer.CourseTestItemAnswer
                              }
                              onRowSelected={item => {
                                 setPlayMediaItem(false);
                                 setAslQuestion(false);
                                 if (isFinalTestReviewEnable) {
                                    if (
                                       finalQuesAnsData.length - 1 >
                                       currentFinalQuesIndex
                                    ) {
                                       if (
                                          rectifyBooleanString(
                                             item.CorrectAnswer,
                                          )
                                       ) {
                                          //incrementFinalQuesIndex();
                                          setTimeout(function () {
                                             incrementFinalQuesIndex();
                                          }, 100);
                                       }
                                    } else if (
                                       rectifyBooleanString(item.CorrectAnswer)
                                    ) {
                                       //Let stop any running media then navigate
                                       setTimeout(function () {
                                          finalReviewSubmited();
                                       }, 100);
                                    }
                                 } else {
                                    handleFinalTestAnswerClicked(item);
                                 }
                              }}
                              onSignButtonPress={url => {
                                 setProgressALSVideo(0);
                                 setAslQuestion(false);
                                 setPlayMediaItem(true);
                                 setAlsVideoUrl(url);
                              }}
                              onMediaClicked={isSameIndex => {
                                 if (isSameIndex) {
                                    setPlayMediaItem(!playMediaItem);
                                 } else {
                                    setPlayMediaItem(true);
                                 }
                                 setAslQuestion(false);
                              }}
                              progressALSVideo={
                                 !isAslQuestion ? progressALSVideo : 0
                              }
                              isMediaPlaying={
                                 !isAslQuestion ? playMediaItem : false
                              }
                              isLandscapeMode={isLandscapeMode}
                              isSmallScreen={() => isLandscapeSmallWebView}
                              finalQuesAnsData={finalQuesAnsData}
                              currentFinalQuesIndex={currentFinalQuesIndex}
                              isImageAvailable={isImageAvailable}
                              isWeb={isWeb}
                              imageURL={imageURL}
                              onImageViewerPressed={() => {
                                 setImageViewer(true);
                              }}
                              wrongAnserID={wrongAnserID}
                              isAslQuestion={isAslQuestion}
                              didVideoStopped={
                                 isAslQuestion ? !playALSVideo : !playMediaItem
                              }
                           />
                        </View>
                     )}
                     {isImageViewer ? (
                        Platform.OS === 'windows' ? (
                           <Popup
                              isOpen={isImageViewer}
                              style={{width: '100%', height: '100%'}}
                              isLightDismissEnabled={true}
                              onDismiss={() => {
                                 setImageViewer(false);
                              }}>
                              <CustomImageViewer
                                 imageURL={imageURL}
                                 onClose={() => {
                                    setImageViewer(false);
                                 }}
                              />
                           </Popup>
                        ) : (
                           <CustomImageViewer
                              imageURL={imageURL}
                              onClose={() => {
                                 setImageViewer(false);
                              }}
                           />
                        )
                     ) : null}
                  </View>
               </ImageBackground>
            </SafeAreaView>
         )}
         {isModalActionSheetVisible ? (
            <ReviewAnswerResponseScreen
               correctResponse={finalQuesAnsData.CorrectResponse}
               incorrectResponse={finalQuesAnsData.IncorrectResponse}
               isCorrect={isCorrectAnswer}
               onClose={() => {
                  if (isCorrectAnswer) {
                     props.onNextPress();
                  }
                  setRetryPressed(true);
                  setIsModalActionSheetVisible(false);
               }}
            />
         ) : null}

         {AslType === 'video' &&
            (isAslQuestion ? playALSVideo : playMediaItem) && (
               <VideoPlayer
                  url={ALSVideoUrl}
                  onPlay={() =>
                     isAslQuestion
                        ? setPlayALSVideo(true)
                        : setPlayMediaItem(true)
                  }
                  onStop={() =>
                     isAslQuestion
                        ? setPlayALSVideo(false)
                        : setPlayMediaItem(false)
                  }
                  setProgress={pro => setProgressALSVideo(pro)}
                  isLandscapeMode={isLandscapeMode}
               />
            )}
      </View>
   );
};

export default ReviewQuestionScreen;
